module.exports = __webpack_public_path__ + "media/metallica-master-of-puppets_ostonline_net.165ce7b2.mp3";